import { render } from "./registered-capital.vue?vue&type=template&id=4e532a01&scoped=true"
import script from "./registered-capital.vue?vue&type=script&lang=js"
export * from "./registered-capital.vue?vue&type=script&lang=js"

import "./registered-capital.vue?vue&type=style&index=0&id=4e532a01&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e532a01"]])

export default __exports__